const scrollToForm = (): void => {
    document.querySelector('#demo')?.scrollIntoView({ behavior: 'smooth' })
}

export default scrollToForm
